import { DateTime, isToday, isTomorrow } from './date-helpers'

export const TODAY_STRING = 'Today'
export const YESTERDAY_STRING = 'Yesterday'
export const TOMORROW_STRING = 'Tomorrow'

export const formatTimeAMPM = dt => dt.format('h[.]mma')

export const formatDay = dt => dt.clone().format('ddd')
export const formatDayNumber = dt => dt.clone().format('Do')
export const formatMonth = dt => dt.clone().format('MMM')
export const formatDayAndMonth = dt => dt.format('D MMM')
export const formatYear = dt => dt.clone().format('YYYY')
export const formatISOWithTime = dt => dt.clone().format('YYYY-MM-DDTHH:mm')

// Mon 19th Feb, Wed 21st Feb ...
export const formatTradingHoursDate = dt =>
  `${formatDay(dt.clone())} ${formatDayNumber(dt.clone())} ${formatMonth(
    dt.clone()
  )}`

// 18:30 to 6:30pm
export const format24Hour = hour =>
  DateTime.moment(hour, 'HH:mm').format('h:mma')

// Today
// Tomorrow
// Mon 19th, Wed 21st ...
// Mon 19th Feb, Wed 21st Feb ...
export const formatHumanDate = (dt, opts = {}) => {
  if (isToday(dt, opts.timeZone)) {
    return TODAY_STRING
  }
  if (isTomorrow(dt, opts.timeZone)) {
    return TOMORROW_STRING
  }

  let str = `${formatDay(dt.clone())} ${formatDayNumber(dt.clone())}`

  if (opts.includeMonth) {
    str = `${str} ${formatMonth(dt.clone())}`
  }

  return str
}

// 9:13am, 2:25pm ...
export const formatTime = dt => dt.clone().format('h:mma').toLowerCase()

// expects date as String ISO 8601 format e.g. 2018-05-14T08:00:00.000Z
export const howLongAgo = (date, timeZone) => {
  const today = DateTime.local({ timeZone }).endOf('day')
  const dt = DateTime.fromISO(date, { timeZone })
  const duration = DateTime.moment.duration(dt.diff(today))

  if (duration.days() > -1) {
    return TODAY_STRING
  }
  // eslint-disable-next-line no-magic-numbers
  if (duration.days() > -2) {
    return YESTERDAY_STRING
  }

  return duration.humanize(true)
}

export const formatTimes = (arr, timeZone) =>
  arr.map(time => ({
    ...time,
    openingTime: formatTime(
      DateTime.fromISO(`${time.date}T${time.openingTime}`, {
        timeZone,
        format: 'HH:mm',
      })
    ),
    closingTime: formatTime(
      DateTime.fromISO(`${time.date}T${time.closingTime}`, {
        timeZone,
        format: 'HH:mm',
      })
    ),
  }))
